<div class="flex items-center flex-wrap gap-6 mb-8 px-3 py-3 justify-between md:flex-row" [class]="totalItems > 0? 'justify-between' : 'justify-end'  ">

  @if(totalItems > 0) {
    <div class="min-w-[100px]">
      <button class="p-2 cursor-pointer" [disabled]="params.limit == 5" [class]="params.limit == 5 ? 'active' : null" (click)="changeLimit(5)">
        <span>5</span>
      </button>|<button class="p-2 cursor-pointer" [disabled]="params.limit == 10" [class]="params.limit == 10 ? 'active' : null" (click)="changeLimit(10)">
        <span>10</span>
      </button>|<button class="p-2 cursor-pointer" [disabled]="params.limit == 30" [class]="params.limit == 30 ? 'active' : null" (click)="changeLimit(30)">
        <span>30</span>
      </button>

    </div>
    <div class="gap-6 py-3 text-center">
      <button (click)="prevPage()" [hidden]="currentPage === 1"  class="basis-6 cursor-pointer align-sub">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m12 19-7-7 7-7"/>
          <path d="M19 12H5"/>
        </svg>
      </button>
      <span class="space-x-6 px-3">Pagina {{ currentPage }}  {{ totalPages > 0 ? 'di ' + totalPages : ''  }}</span>
      <button (click)="nextPage()" [hidden]="currentPage === totalPages " class="basis-6 cursor-pointer align-sub">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12h14"/>
          <path d="m12 5 7 7-7 7"/>
        </svg>
      </button>


  </div>
  }
  <div class="ml-auto md:ml-0">
    Risultati: {{totalItems}}
  </div>
</div>

